import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, Send, CheckCircle2, AlertTriangle } from "lucide-react";

export const AdminEmail = () => {
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { api.get("/admin/email-status").then((r) => setStatus(r.data)).catch(() => setStatus({ configured: false })); }, []);

  const sendTest = async () => {
    setSending(true); setResult(null);
    try {
      const { data } = await api.post("/admin/email-test");
      setResult({ ok: true, to: data.to, id: data.id });
      toast.success(`E-mail de test envoyé à ${data.to}`);
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || "Échec de l'envoi";
      setResult({ ok: false, msg });
      toast.error(msg);
    } finally { setSending(false); }
  };

  return (
    <div className="bg-white rounded-2xl p-6 border border-slate-200 max-w-2xl space-y-4" data-testid="admin-email">
      <div className="flex items-center gap-2"><Mail className="w-5 h-5 text-blue-600" /><h2 className="font-heading font-semibold">E-mails transactionnels (Resend)</h2></div>
      {status && (
        <div className={`flex items-start gap-2 rounded-xl px-4 py-3 text-sm ${status.configured ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-amber-50 text-amber-800 border border-amber-200"}`} data-testid="email-status">
          {status.configured ? <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" /> : <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />}
          <div>
            <p className="font-medium">{status.configured ? "Resend configuré" : "Resend non configuré"}</p>
            <p className="text-xs mt-0.5">Expéditeur : {status.from_name} &lt;{status.from_email || "—"}&gt;. La clé API reste côté serveur et n'est jamais affichée.</p>
            {!status.configured && <p className="text-xs mt-1">Renseignez RESEND_API_KEY dans les Secrets Emergent (Republish → Secrets → Custom keys), puis redémarrez le backend.</p>}
          </div>
        </div>
      )}
      <Button onClick={sendTest} disabled={sending || !status?.configured} data-testid="send-test-email-button" className="bg-blue-600 hover:bg-blue-700 rounded-xl">
        <Send className="w-4 h-4 mr-2" /> {sending ? "Envoi..." : "Envoyer un e-mail de test"}
      </Button>
      {result && <p className={`text-sm ${result.ok ? "text-emerald-700" : "text-red-600"}`} data-testid="email-test-result">{result.ok ? `Envoyé à ${result.to} (id ${result.id})` : result.msg}</p>}
      <p className="text-xs text-slate-400">L'e-mail de test est envoyé à l'adresse de l'administrateur connecté. Utilisé pour : réinitialisation du mot de passe, notification du rapport mensuel.</p>
    </div>
  );
};
